//
//
//
//
//

import sport_icons from '~/data/sport_icons';
import sport_icons_alt from '~/data/sport_icons_alt';
export default {
    props: ['sport'],
  data() {
    return {
      icons: sport_icons,
    }
  },
    computed: {
        icon() {
            let icon_alt = _.get(sport_icons_alt, this.sport.slug, 'badge')
            let icon = _.get(sport_icons, this.sport.slug, 'badge')
            if(['pelota'].includes(this.sport.slug)) {
              return 'sportify-'+_.get(sport_icons_alt, 'pelota', 'badge')
            }
            if(icon_alt != icon)
              return 'fa-duotone fa-'+icon_alt
           return 'vb-'+icon
           //return _.get(sport_icons, this.sport.slug, 'badge')
        },
    },
    methods: {

  }
}
